var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"subscribe"},[_c('span',[_vm._v("预约演示,获取尊享服务")]),_c('span',[_vm._v("预约产品和方案演示,提供专属于您的服务")]),_c('div',{staticClass:"btn"},[_c('div',{staticClass:"icon iconfont icon-ic_yunweiguanli"}),_vm._v(" 预约演示 ")])])
}]

export { render, staticRenderFns }